import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '@redux/hooks';
import { getParams } from '@entities/Filter';
import { bannerActions, generateBanners } from '@entities/BannerPage';
import { selectRegion } from '@redux/slices/header';
import { ProductSpecifications } from '@entities/Product';

export const useSyncBannerWithFilters = () => {
  const dispatch = useAppDispatch();
  const params = useAppSelector(getParams);
  const season = params[ProductSpecifications.TyresSeason];
  const { REGION: regionId, REGION_TYPE: regionType } = useAppSelector(selectRegion);
  const router = useRouter();

  useEffect(() => {
    const banners = generateBanners({
      urlPage: router.asPath,
      season,
      regionId: parseInt(regionId),
      regionType,
    });

    dispatch(bannerActions.setBanners(banners));
  }, [season, router.asPath]);
};
